import React from 'react'
import styled, { css } from 'styled-components'

const StyledInput = styled.textarea`
  border-radius: 20px;
  border: 1px solid #e1e4e8;
  color: #0a1f44;
  font-size: 14px;
  line-height: 1.71;
  margin-top: 0;
  padding: 7.5px 12px;
  width: 100%;

  &:focus {
    font-weight: 500;

    &::placeholder {
      font-weight: initial;
    }
  }

  &::placeholder {
    color: #8a94a6;
  }

  &:disabled {
    background-color: #f7f8f9;
    cursor: 'default';

    &::placeholder {
      color: #b0b7c3;
    }
  }

  ${({ error }) =>
    error &&
    css`
      border: 1px solid ${({ theme }) => theme.colors.red};
      color: ${({ theme }) => theme.colors.red};

      &::placeholder {
        color: ${({ theme }) => theme.colors.red};
      }
    `}
`

const StyledInputWrapper = styled.div`
  align-items: start;
  display: ${({ textarea }) => (textarea ? 'flex' : 'none')};
  flex-direction: column;
  margin-bottom: 16px;
  position: relative;
  width: 100%;
`

const StyledLabel = styled.label`
  color: #4e5d78;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.67;

  ${({ error }) =>
    error &&
    css`
      color: #c02428;
    `}
`

const StyledError = styled.p`
  bottom: -21px;
  color: ${({ theme }) => theme.colors.red};
  font-size: 12px;
  line-height: 1.71;
  position: absolute;
`

const Textarea = ({
  cmsData,
  errors,
  id,
  label,
  name,
  onChange,
  placeholder,
  required,
  textarea,
  type,
  value,
}) => {

  return (
    <StyledInputWrapper textarea={cmsData ? cmsData.textarea : textarea} >
      <StyledLabel 
        error={errors} 
        htmlFor={id}>
        {label}
      </StyledLabel>
      <StyledInput
        autoComplete="off"
        error={errors}
        id={id}
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        type={type}
        value={value}
      />
      {errors && <StyledError>{errors}</StyledError>}
    </StyledInputWrapper>
  )
}
export default Textarea